module.exports = __webpack_public_path__ + "static/img/蒙版组 36.e0c6eb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/蒙版组 36.png
// module id = X0mP
// module chunks = 0